import { fileRequiredValidate } from "validators";
import * as yup from "yup";

const createNewsValidator = yup
  .object({
    title: yup.string().required("Title is required"),
    image: yup
      .mixed()
      .required("Image is required")
      .test("image-required", "Image is required", fileRequiredValidate),
    content: yup.string().required("Content is required"),
  })
  .required();

export default createNewsValidator;
